import React, { FocusEventHandler, FormEventHandler } from 'react';
import { Heading } from '@mos-cat/typography';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { t, Trans } from '@lingui/macro';
import {
  getPayload,
  setErrorToRelativeFields,
  trimOnBlur,
} from '../../../helpers/handlers';
import TextField from '../../shared/TextField/TextField';
import { i18n } from '../../../helpers/i18n';
import {
  isDateInvalid,
  maxAcceptableDate,
  minAcceptableDate,
} from '../../../helpers/dateHelpers';
import { Field } from '../../../declarations/widget-ums';
import { CHILD } from '../../../models/child';
import { ERROR_DATE } from '../../../constants/errors';
import { getErrorLocation } from '../../../helpers/errorLocation';
import DateField from '../../shared/DateField/DateField';
import { PATERNITY_PATTERN } from '../../../constants/REGEXP_PATTERNS';

interface Props {
  paternityRegisterDate: Field<string>;
  paternityRegisterNumber: Field<string>;
  birthdateValue: string;
  onChange: FormEventHandler;
  onBlur: FocusEventHandler;
  trimOnBlur: FocusEventHandler;
}

function Paternity({
  paternityRegisterDate,
  paternityRegisterNumber,
  birthdateValue,
  onChange,
  onBlur,
  trimOnBlur,
}: Props): JSX.Element {
  return (
    <div className="Paternity StepContentBlock">
      <Heading level={3} className="PguFormGrid__row">
        <Trans>Сведения об установлении отцовства</Trans>
      </Heading>
      <div className="PguFormGrid__row">
        <DateField
          errorLocation={getErrorLocation(
            paternityRegisterDate,
            ERROR_DATE.BIRTHDATE_EARLY_PATERNITY_DATE
          )}
          className="PguFormGrid_col"
          name="paternityRegisterDate"
          placeholder={i18n._(t`Дата регистрации установления отцовства`)}
          {...paternityRegisterDate}
          onChange={onChange}
          minDate={
            isDateInvalid(birthdateValue) ? minAcceptableDate : birthdateValue
          }
          maxDate={maxAcceptableDate}
          onBlur={onBlur}
        />
      </div>
      <div className="PguFormGrid__row">
        <TextField
          className="PguFormGrid_col"
          placeholder={i18n._(t`Номер свидетельства об установлении отцовства`)}
          inputProps={{
            name: 'paternityRegisterNumber',
            ...paternityRegisterNumber,
            onChange,
            onBlur: trimOnBlur,
            maxLength: 200,
          }}
          maskOptions={{
            regex: PATERNITY_PATTERN.FOR_INPUT_MASK,
            placeholder: ' ',
            showMaskOnFocus: false,
            showMaskOnHover: false,
          }}
        />
      </div>
    </div>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange(event) {
    const payload = getPayload(event);

    if (event.target.name === 'paternityRegisterDate') {
      setErrorToRelativeFields(dispatch, CHILD, ['birthdate']);
    }
    dispatch({
      type: 'child/secondParent/change',
      payload,
    });
  },
  onBlur({ target: { name, value } }) {
    dispatch({
      type: `child/validate/field`,
      payload: { namespace: CHILD, name, value },
      additionalNamespace: 'secondParent',
    });
  },
  trimOnBlur: trimOnBlur('child/secondParent', dispatch),
});

export default connect(
  ({
    child: {
      birthdate: { value: birthdateValue },
      secondParent: { paternityRegisterDate, paternityRegisterNumber },
    },
  }) => ({
    paternityRegisterDate,
    paternityRegisterNumber,
    birthdateValue,
  }),
  mapDispatchToProps
)(Paternity);
